export class Utils{
    static yearMonthDay(date: Date) {
       return date.getFullYear()+'-' + (date.getMonth()+1) + '-'+date.getDate();
    }



     static generateAvatar(firstName: string, lastName: string): string {
        // Generate random background color
        const randomColor = this.getRandomColor();
    
        // Capitalize initials
        const initials = this.getInitials(firstName, lastName);
    
        // Create avatar SVG markup
        const svgMarkup = `
            <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                <rect width="100%" height="100%" fill="${randomColor}" />
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#fff" font-size="40">${initials}</text>
            </svg>
        `;
    
        return `data:image/svg+xml,${encodeURIComponent(svgMarkup)}`;
    }
    
     static getRandomColor(): string {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
    
     static getInitials(firstName: string, lastName: string): string {
        const firstInitial = firstName.charAt(0).toUpperCase();
        const lastInitial = lastName.charAt(0).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    }
}